import { mapActions } from 'vuex'
import Modal from '@/components/modals/modal/modal.vue'
import {mask} from 'vue-the-mask'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'ChangeStartTimeModal',
  props: {
    order: {
      type: Object
    }
  },
  components: {
    Modal,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      newDate: ''
    }
  },
  methods: {
    ...mapActions({
      updateOrder: 'orders/updateOrder'
    }),
    show () {
      if (this.order) {
        this.newDate = this.$moment(this.order.times.start_at).format('HH:mm')
      }
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    onSubmit() {
      this.$refs['observer'].validate().then(async success => {
        if (success) {
          const newTimeMoment = this.$moment(this.newDate, 'HH:mm')
          const newStartAtDate = this.$moment(this.order.times.start_at)
          .hours(newTimeMoment.hours())
          .minutes(newTimeMoment.minutes())
          const deleveryDate = this.$moment(this.order.times.delivery_to)
          if (newStartAtDate > deleveryDate) {
            const today = this.$moment()
            newStartAtDate
              .year(today.year())
              .month(today.month())
              .date(today.date())
          }
          await this.updateOrder({
            orderId: this.order.id,
            data: {
              action: 'modify_start_time',
              start_time: newStartAtDate.utc().format()
            }
          })
          this.newDate = ''
          this.hide()
        }
      })
    }
  },
  directives: {
    mask
  },
  watch: {
    order() {
      this.newDate = ''
    }
  }
}